import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';


import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { Container } from '@mui/material';
import useNotificationsStore from 'Store/notificationsStore';
import { useTranslation } from 'react-i18next'

interface Props {}
const Notifications: React.FC<Props> = () => {
  const { t } = useTranslation()

  const loading = useNotificationsStore((state) => state.loading);
  const notifications = useNotificationsStore((state) => state.notifications);
  const fetchNotifications = useNotificationsStore((state) => state.fetchNotifications);

  React.useEffect(() => {
    fetchNotifications()
  }, [])

  if (loading) {
    return (
        <Container>
            <Stack spacing={1}>
                <Stack  style={{width: '100%'}} direction="row" spacing={1}>
                    <Skeleton variant="circular" width={50} height={50} />
                    <Stack style={{width: 'calc(100% - 60px)'}} spacing={1}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="rectangular" height={30} />
                    </Stack>
                </Stack>
                <Stack  style={{width: '100%'}} direction="row" spacing={1}>
                    <Skeleton variant="circular" width={50} height={50} />
                    <Stack style={{width: 'calc(100% - 60px)'}} spacing={1}>
                        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                        <Skeleton variant="rectangular" height={30} />
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    );
  }
  if (notifications.length === 0) {
    return <Container><h5 style={{justifySelf: 'center'}}>{t('notifiactions_no_notification_message')}</h5></Container>
  }
  return (
    <Container>
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                </ListItemAvatar>
                <ListItemText
                primary="Brunch this weekend?"
                secondary={
                    <React.Fragment>
                    <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: 'text.primary', display: 'inline' }}
                    >
                        Ali Connors
                    </Typography>
                    {" — I'll be in your neighborhood doing errands this…"}
                    </React.Fragment>
                }
                />
            </ListItem>
            <Divider variant="inset" component="li" />
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                <Avatar alt="Travis Howard" src="/static/images/avatar/2.jpg" />
                </ListItemAvatar>
                <ListItemText
                primary="Summer BBQ"
                secondary={
                    <React.Fragment>
                    <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: 'text.primary', display: 'inline' }}
                    >
                        to Scott, Alex, Jennifer
                    </Typography>
                    {" — Wish I could come, but I'm out of town this…"}
                    </React.Fragment>
                }
                />
            </ListItem>
            <Divider variant="inset" component="li" />
            <ListItem alignItems="flex-start">
                <ListItemAvatar>
                <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                </ListItemAvatar>
                <ListItemText
                primary="Oui Oui"
                secondary={
                    <React.Fragment>
                    <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: 'text.primary', display: 'inline' }}
                    >
                        Sandra Adams
                    </Typography>
                    {' — Do you have Paris recommendations? Have you ever…'}
                    </React.Fragment>
                }
                />
            </ListItem>
        </List>
    </Container>
  );
}

export default Notifications
